import React, { useState, useEffect } from 'react';
import { Menu, X, ChevronRight } from 'lucide-react';
import { Button } from '../ui/button';

const companyName = "Smart Solutions Group";

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ease-out ${isScrolled
          ? 'bg-black/95 backdrop-blur-xl border-b border-white/5 py-4'
          : 'bg-transparent py-6'
        }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between">
          <a href="#hero" className="group flex items-center gap-3">
            <div className="w-10 h-10 rounded-lg bg-gradient-to-br from-amber-600/80 to-amber-800/60 flex items-center justify-center transition-transform duration-300 group-hover:scale-105">
              <span className="text-white font-bold text-lg">S</span>
            </div>
            <div className="hidden sm:block">
              <span className="text-white font-semibold text-lg tracking-tight">
                {companyName}
              </span>
            </div>
          </a>

          <nav className="hidden lg:flex items-center gap-10">
            <a href="#hero" className="text-slate-400 hover:text-white text-sm font-medium tracking-wide transition-colors duration-300 relative group">
              Início
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-amber-500/70 transition-all duration-300 group-hover:w-full" />
            </a>
            <a href="#produtos" className="text-slate-400 hover:text-white text-sm font-medium tracking-wide transition-colors duration-300 relative group">
              Produtos
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-amber-500/70 transition-all duration-300 group-hover:w-full" />
            </a>
            <a href="#sobre" className="text-slate-400 hover:text-white text-sm font-medium tracking-wide transition-colors duration-300 relative group">
              Sobre Nós
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-amber-500/70 transition-all duration-300 group-hover:w-full" />
            </a>
            <a href="#contato" className="text-slate-400 hover:text-white text-sm font-medium tracking-wide transition-colors duration-300 relative group">
              Contato
              <span className="absolute -bottom-1 left-0 w-0 h-px bg-amber-500/70 transition-all duration-300 group-hover:w-full" />
            </a>
          </nav>

          <div className="hidden lg:block">
            <a href="#contato">
              <Button
                className="bg-amber-600/90 hover:bg-amber-500 text-white border-0 px-6 py-2.5 text-sm font-medium tracking-wide transition-all duration-300 hover:shadow-lg hover:shadow-amber-500/20"
              >
                Solicitar Cotação
                <ChevronRight className="w-4 h-4 ml-1" />
              </Button>
            </a>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="lg:hidden p-2 text-slate-400 hover:text-white transition-colors"
          >
            {isMobileMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>

        <div
          className={`lg:hidden overflow-hidden transition-all duration-500 ease-out ${isMobileMenuOpen ? 'max-h-96 opacity-100 mt-6' : 'max-h-0 opacity-0'
            }`}
        >
          <nav className="flex flex-col gap-4 pb-6">
            <a href="#hero" onClick={() => setIsMobileMenuOpen(false)} className="text-slate-400 hover:text-white text-base font-medium transition-colors py-2 border-b border-slate-800/50">
              Início
            </a>
            <a href="#produtos" onClick={() => setIsMobileMenuOpen(false)} className="text-slate-400 hover:text-white text-base font-medium transition-colors py-2 border-b border-slate-800/50">
              Produtos
            </a>
            <a href="#sobre" onClick={() => setIsMobileMenuOpen(false)} className="text-slate-400 hover:text-white text-base font-medium transition-colors py-2 border-b border-slate-800/50">
              Sobre Nós
            </a>
            <a href="#contato" onClick={() => setIsMobileMenuOpen(false)} className="text-slate-400 hover:text-white text-base font-medium transition-colors py-2 border-b border-slate-800/50">
              Contato
            </a>
            <a href="#contato" onClick={() => setIsMobileMenuOpen(false)}>
              <Button className="w-full bg-amber-600/90 hover:bg-amber-500 text-white mt-2">
                Solicitar Cotação
              </Button>
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
